import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { AppConfig } from '@config/app.config';
import { GeneralsService } from '@core/services/generals.service';
import { RulesService } from '@core/services/rules.service';
import { RulesEditComponent } from '@modules/rules/rules-edit/rules-edit.component';
import { Constants } from '@shared/class/constants.class';
import { Rule } from '@shared/interfaces/rule';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-rules-list',
  templateUrl: './rules-list.component.html'
})
export class RulesListComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public location = 'rules';
  public dataSource: MatTableDataSource<Rule>;
  public selection = new SelectionModel<Rule>(true, []);
  public rulesList: Array<Rule> = [];
  public rule: Rule;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('filter') filterInput: ElementRef;

  constructor(
    public appConfig: AppConfig,
    public generalsService: GeneralsService,
    public rulesService: RulesService
  ) {
    this.constants.displayedColumns = [
      this.appConfig.ACTIONS.delete.id,
      'id',
      'name',
      this.appConfig.ACTIONS.edit.id
    ];
  }

  ngOnInit() {
    this.generalsService.action$
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe((result: any) => {
        if (result) {
          const actions = this.generalsService.getActions(
            this.constants.displayedColumns,
            this.constants.actionsList,
            this.location
          );
          this.constants.displayedColumns = actions.displayedColumns;
          this.constants.displayedActions = actions.displayedActions;
          this.loadData();
        }
      });
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  loadData() {
    this.constants.loading = true;
    this.constants.elements = true;
    this.rulesService
      .getItems()
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe(
        result => {
          this.rulesList = [];
          result.data.forEach((element: any) => {
            this.rule = { id: element.id, name: element.attributes.name };
            this.rulesList.push(this.rule);
          });
          if (this.rulesList.length) {
            this.dataSource = new MatTableDataSource(this.rulesList);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.constants.filter = this.dataSource.filteredData;
            this.selection.clear();
          } else {
            this.constants.elements = false;
          }

          this.constants.error = false;
          this.constants.loading = false;
        },
        error => {
          this.constants.errorText = this.generalsService.showError(error);
          this.constants.error = true;
          this.constants.loading = false;
        }
      );
  }

  reload() {
    this.generalsService.reload(this);
  }

  edit(action: string, item?: Rule) {
    let dialog: any;

    const data = {
      action: action,
      item: {}
    };

    if (action === this.appConfig.ACTIONS.add.id) {
      this.constants.message = this.appConfig.LANG.message.addSuccess;
    } else {
      data.item = item;
      this.constants.message = this.appConfig.LANG.message.editSuccess;
    }

    dialog = this.generalsService.modal(RulesEditComponent, data);

    dialog
      .afterClosed()
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe((result: any) => {
        this.generalsService.afterClosed(this, result, this.constants.message);
      });
  }

  selectDelete() {
    const numSelected = this.selection.selected.length,
      numRows = this.dataSource.data.length;

    this.constants.labelDelete = this.generalsService.messageSelectedDelete(
      'label',
      numSelected,
      numRows
    );
  }

  filterData(event: any) {
    this.generalsService.applyFilter(this.dataSource, event);
    this.constants.filter = this.dataSource.filteredData;
  }
}
